import styled from "styled-components";
import {
	FONT_SIZE_18,
	COLOR_WHITE,
	FONT_SIZE_16,
} from "@website-builder/utilities-index";

export const Title = styled.div`
	width: 100%;
	height: 50px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	margin-top: 10px;
	background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const Description = styled.div`
	width: 100%;
	text-align: center;
	color: ${COLOR_WHITE};
	margin-top: 10px;
	margin-bottom: 10px;
	.smallFont {
		font-size: ${FONT_SIZE_16};
	}
`;

export const Details = styled.div`
	font-size: ${FONT_SIZE_18};
`;

export const ProgramDetailsWrapper = styled.div`
	margin-top: 20px;
	margin-bottom: 20px;
`;
